import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { ActionButton } from "@zfp-akademie-a-s/zfp-design";
import { EditIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useEffect, useState } from "react";

type Props = {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly readOnly?: boolean;
};

const StyledInput = styled.input`
  outline: 0;
  border: 0;
  font-size: 24px;
  font-family: ${({ theme }) => theme.typography.h2.fontFamily};
  background: transparent;
  width: 100%;
`;

export const EditableTitle: React.FC<Props> = (props) => {
  const { t } = useResource();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState<string>(props.value);

  const handleSave = () => {
    setIsEditing(false);
    props.onChange(value);
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  if (!isEditing) {
    return (
      <Box component="span" display="flex" alignItems="center">
        <Typography variant="h2" component="span">
          {value}
        </Typography>
        {!props.readOnly && (
          <ActionButton label={t(Resources.Common.Edit)} icon={<EditIcon />} onClick={() => setIsEditing(true)} sx={{ ml: 2 }} />
        )}
      </Box>
    );
  }

  return (
    <StyledInput
      maxLength={50}
      value={value}
      onBlur={handleSave}
      onChange={(event) => {
        setValue(event.target.value);
      }}
      onKeyDown={(event) => (event.key === "Enter" || event.key === "Escape") && handleSave()}
      autoFocus
    />
  );
};
